// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__1adnH","load2":"spinner_load2__29Kb-"};